@if (open()) {
  <div #panel class="twk-panel" cdkDrag cdkDragBoundary="body">
    <div class="twk-hd" cdkDragHandle>
      <b>{{ title() }}</b>
      <button type="button" class="twk-x" aria-label="Close tweaks" (click)="open.set(false)">✕</button>
    </div>
    <div class="twk-body">
      <ng-content></ng-content>
    </div>
  </div>
}
